export default __webpack_public_path__ + "static/media/callsheet.5fc3cf9f.png";